import styled from "styled-components"
import { Typography, CircularProgress } from "@mui/material"
import Container from "@mui/material/Container"

import Box from "@mui/material/Box"
import CustomButton from "../../components/custom-button/custom-button.component"

export const Wrapper = styled.div`
  padding-top: 4em;
  padding-bottom: 2em;

  .wrapper {
    max-width: 550px;
    margin: auto;

    p {
      color: #000000;
      font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    }
  }
`

export const CustomForm = styled.form`
  padding-top: 4em;
  padding-bottom: 4em;

  .MuiInput-root {
    margin-bottom: 0.5em;
  }

  .custom-button {
    margin-top: 3em;
  }

  .MuiCheckbox-root {
    color: white;
  }

  .MuiFormControlLabel-root {
    width: 100%;
  }

  .MuiFormControlLabel-label {
    text-align: left;
  }

  .MuiInput-underline {
    &:before {
      content: unset;
    }
  }

  .MuiOutlinedInput-input {
    color: black;
  }

  input,
  textarea {
    background-color: rgba(0, 0, 0, 0.1);
    //border: 0.25px solid rgba(0, 0, 0, 0.25);
    border: unset;
    border-radius: 2px;
    color: #000000;
  }

  input {
    padding: 0.7em 1em;
  }

  textarea {
    padding: 0.4em 1em;
    height: 200px !important;
    width: 100% !important;
  }

  .date {
    display: flex;
    flex-direction: column;
  }

  .date-time {
    .MuiFormControl-root {
      width: 100%;
    }

    > div {
      &:first-child {
        padding-right: 0.5rem;
      }

      &:last-child {
        padding-left: 0.5rem;
      }
    }
  }

  label {
    font-weight: 500;

    sup {
      font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    }
  }

  .comments {
    display: flex !important;
    flex-direction: column !important;

    textarea {
      resize: none;
    }
  }
`
export const ItemsWrapper = styled(Container)`
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  color: white;
  padding-top: 2em;
  padding-bottom: 2em;
  text-align: left;
`

export const Title = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  font-weight: bold;
  margin-bottom: 1.5em;

  &:after {
    content: "";
    position: relative;
    background-color: white;
    height: 1px;
    display: block;
    margin-top: 1em;
    width: 70px;
  }
`
export const BottomItems = styled.div`
  .MuiGrid-item {
    text-align: center;

    ${({ theme }) => theme.breakpoints.up("md")} {
      &:first-child {
        text-align: left;
      }

      &:last-child {
        text-align: right;
      }
    }
  }
`

export const FormSpinner = styled(Box)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  //background-color: rgba(0,0,0,0.1);
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

export const CustomSpinner = styled(CircularProgress)`
  color: ${({ theme }) =>
    theme.palette ? theme.palette.secondary.main : `black`};
  width: 60px !important;
  height: 60px !important;
`

export const SuccessMessage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 1.5rem;
    text-align: center;
  }
`

export const Button = styled(CustomButton)`
  margin-top: 4em;
  text-transform: unset;
  border-radius: 2px;
  padding: 0.5em 0;
`
